import App from './views/App.svelte';

const app = new App({
	target: document.body,
});

export default app;
